"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TooltipContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__TooltipContainer",
  componentId: "sc-7864ik-0"
})(["display:inline-block;position:relative;text-align:left;cursor:pointer;.tooltipContent{display:none;position:absolute;}&:hover{.tooltipContent{display:block !important;transform:translate(-50%,-100%);}}"]);

var TooltipContent = _styledComponents["default"].div.withConfig({
  displayName: "styles__TooltipContent",
  componentId: "sc-7864ik-1"
})(["top:0%;left:50%;transform:translateY(-50%);z-index:99999999;display:none;position:absolute;background:rgba(62,65,72,0.75);color:#fff;font-size:12px;font-family:Lato-Regular;font-weight:normal;letter-spacing:0.25px;line-height:16px;padding:8px;"]);

var _default = {
  TooltipContainer: TooltipContainer,
  TooltipContent: TooltipContent
};
exports["default"] = _default;